import { motion } from 'framer-motion';
import TrustedFeature from './TrustedFeature';
import { FaCube, FaCoins, FaLock, FaUsers } from 'react-icons/fa';

const features = [
  {
    icon: <FaCube className="text-4xl" />,
    title: "OP BNB",
    description: "Empowering decentralized finance with efficiency and scalability on OPBNB L2 Chain."
  },
  {
    icon: <FaCoins className="text-4xl" />,
    title: "BNB",
    description: "Efficient coin transactions facilitated seamlessly through OPBNB's infrastructure."
  },
  {
    icon: <FaLock className="text-4xl" />,
    title: "Smart Contract",
    description: "Automating agreements securely with transparent blockchain smart contracts."
  },
  {
    icon: <FaUsers className="text-4xl" />,
    title: "No Admin",
    description: "Decentralized governance ensures autonomy and transparency without administrators."
  }
];

const Trusted = () => {
  return (
    <div className="bg-secondary py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-primary text-lg">Trusted Worldwide</span>
          <h2 className="text-3xl font-bold text-white mt-2 mb-6">
            Globally Trusted, Valued by Thousands
          </h2>
          <p className="text-gray-300 max-w-3xl mx-auto">
            At MO BNB, we're committed to dismantling barriers and fostering a more inclusive financial landscape. Join us to embark on the path to a brighter, financially independent future.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <TrustedFeature key={index} {...feature} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Trusted;